/**
 * Fixed role accent colors for event UI (payroll list dots, legends, etc.).
 * Names match backend English role labels; lookup is case-insensitive.
 */

export const EVENT_ROLE_COLOR_BY_NAME = {
  traffic: "var(--color-cyan-800, #00A2B8)",
  usher: "var(--color-primary-default, #9645FF)",
  security: "var(--color-destructive-default, #DC2626)",
  "host/ess": "var(--color-warning-500, #F59E0B)",
  "host/hostess": "var(--color-warning-500, #F59E0B)",
  host: "var(--color-warning-500, #F59E0B)",
  hostess: "var(--color-warning-500, #F59E0B)",
  cleaner: "var(--color-success-default, #059669)",
  photographer: "var(--color-fuchsia-default, #D946EF)",
  supervisor: "var(--color-primary-default, #9645FF)",
  guard: "var(--color-foreground-muted, #64748B)",
};

/** Fallback palette when role name is unknown. */
const EVENT_ROLE_FALLBACK_COLORS = [
  "var(--color-primary-default, #9645FF)",
  "var(--color-cyan-800, #00A2B8)",
  "var(--color-destructive-default, #DC2626)",
  "var(--color-warning-500, #F59E0B)",
  "var(--color-success-default, #059669)",
  "var(--color-fuchsia-default, #D946EF)",
  "var(--color-foreground-muted, #64748B)",
];

const normalizeRoleName = (name) =>
  String(name ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

const hashRoleName = (normalized) => {
  let hash = 0;
  for (let i = 0; i < normalized.length; i += 1) {
    hash = (hash * 31 + normalized.charCodeAt(i)) >>> 0;
  }
  return hash;
};

export const getEventRoleColor = (name) => {
  const normalized = normalizeRoleName(name);
  if (!normalized) {
    return EVENT_ROLE_FALLBACK_COLORS[0];
  }

  if (EVENT_ROLE_COLOR_BY_NAME[normalized]) {
    return EVENT_ROLE_COLOR_BY_NAME[normalized];
  }

  return EVENT_ROLE_FALLBACK_COLORS[
    hashRoleName(normalized) % EVENT_ROLE_FALLBACK_COLORS.length
  ];
};
